var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.902 7.875l.403-2.534H5.788V3.697c0-.693.351-1.369 1.479-1.369H8.41V.171S7.372 0 6.38 0C4.307 0 2.952 1.214 2.952 3.41v1.931H.648v2.534h2.304V14h2.836V7.875h2.114z",
    fill: "#3A92E5"
  })));
}
export default SvgFacebook;